import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ListClips from './list-clips';
import ListHighlightReels from './highlight-reels-list';
import ListNotes from './list-notes';
import ListTagHighlights from './list-tag-hilights';
import ModalWithColunms from '../../modal-with-colunms';

const MODAL_TITLE = 'Click to add research to your report';

const TABS = {
  CLIPS: { key: 'CLIPS', text: 'Clips' },
  HIGHLIGHT_REEL: { key: 'HIGHLIGHT_REEL', text: 'Highlight Reels' },
  TAGS: { key: 'TAGS', text: 'Tags' },
  NOTES: { key: 'NOTES', text: 'Notes' },
};

const ReportResearchModal = (props) => {
  const {
    open,
    onClose,
    companyId,
    onSetTestSessionNotes,
    onSetHighlightReels,
    onSetNotes,
    onSetTags,
    project,
  } = props;

  const [selectedTab, setSelectedTab] = useState(TABS.CLIPS.key);

  const handleClose = () => {
    onClose();
  };

  return (
    <ModalWithColunms
      tabs={TABS}
      open={open}
      onClose={handleClose}
      onSelectTab={(tab) => setSelectedTab(tab)}
      selectedTab={selectedTab}
      modalTitle={MODAL_TITLE}
    >
      <>
        {selectedTab === TABS.CLIPS.key && (
          <ListClips
            companyId={companyId}
            isModalOpen={open}
            onSetTestSessionNotes={onSetTestSessionNotes}
            project={project}
          />
        )}

        {selectedTab === TABS.HIGHLIGHT_REEL.key && (
          <ListHighlightReels
            companyId={companyId}
            isModalOpen={open}
            onSetHighlightReels={onSetHighlightReels}
          />
        )}

        {selectedTab === TABS.TAGS.key && (
          <ListTagHighlights
            companyId={companyId}
            isModalOpen={open}
            onSetTags={onSetTags}
            project={project}
          />
        )}

        {selectedTab === TABS.NOTES.key && (
          <ListNotes
            companyId={companyId}
            isModalOpen={open}
            onSetNotes={onSetNotes}
            project={project}
          />
        )}
      </>
    </ModalWithColunms>
  );
};

ReportResearchModal.propTypes = {
  companyId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onSetHighlightReels: PropTypes.func.isRequired,
  onSetNotes: PropTypes.func.isRequired,
  onSetTags: PropTypes.func.isRequired,
  onSetTestSessionNotes: PropTypes.func.isRequired,
  open: PropTypes.bool,
  project: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

ReportResearchModal.defaultProps = {
  open: false,
};

export default ReportResearchModal;
